import { COURSE_LIST_REQUEST } from '../actions';

export default function(state=null, action){

  switch (action.type) {
    case COURSE_LIST_REQUEST:
      if (action.payload.data!==undefined)
        return action.payload.data.listado;
      else return null;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/listado_cursos_reducer.js